// Accès à l'onboarding « Par quoi commencer ».
//
// FAIL-CLOSED par défaut. L'accès est ouvert dans deux cas :
//  1. l'e-mail est dans la liste blanche interne (équipe) — toujours ;
//  2. le compte est un ABONNÉ PAYANT ACTIF — ouverture générale décidée par Charly le
//     22/07/2026 (même règle que l'assistant chat et l'État des lieux).
//
// Les comptes gratuits ou non connectés ne voient donc PAS l'onboarding (cas 2 = payants
// seulement). E-mails en minuscules. Même modèle que overviewAccess.js / edlAccess.js.
const ONBOARDING_ALLOWLIST = ['charly.leggeri@limeare.com', 'axel@horiz.io']

// E-mail de connexion (Keycloak), en minuscules. '' si non lisible -> non autorisé.
function getCurrentEmail() {
  const tp = (typeof window !== 'undefined' && window.keycloak && window.keycloak.tokenParsed) || null
  if (!tp) return ''

  return (tp.email || (tp.rl_profile && tp.rl_profile.username) || '').trim().toLowerCase()
}

// Client PAYANT ACTIF (même règle que edlAccess.js / chatAssistantAccess.js) : plan
// renseigné, différent de 'free'/'no-plan', ET subscribed=true. Keycloak sérialise
// 'subscribed' en booléen OU en chaîne 'true' selon le flux : on accepte les deux formats.
function isCurrentUserPayingClient() {
  const tp = (typeof window !== 'undefined' && window.keycloak && window.keycloak.tokenParsed) || null
  const rl = (tp && tp.rl_profile) || {}
  const plan = (rl.plan || '').trim().toLowerCase()
  const subscribed = rl.subscribed === true || rl.subscribed === 'true'

  return !!plan && plan !== 'free' && plan !== 'no-plan' && subscribed
}

export function isOnboardingEnabled() {
  const email = getCurrentEmail()

  // Équipe interne (liste blanche) : toujours.
  if (email && ONBOARDING_ALLOWLIST.includes(email)) {
    return true
  }

  // Ouverture générale : tous les abonnés payants actifs.
  return isCurrentUserPayingClient()
}
